import {AppSingletonUtil} from 'src/app/Util/AppSingletonUtil';
import {StorageService} from './../../Service/StorageService';
import {MainDisplayComponent} from './Display/MainDisplayComponent';
import {Params, Router} from '@angular/router';
import {AfterViewInit, Component, ViewChild, ViewContainerRef} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {AlertController, LoadingController} from '@ionic/angular';
import {AppViewReceiverConst} from 'src/app/Util/AppReceiver/AppViewReceiverConst';
import {BaseViewUI} from '../BaseUI/BaseViewUI/BaseViewUI';
import {AppMainViewController} from './AppMainViewController';
import {ViewSpinnerComponent} from '../ViewSpinnerComponent';
import { MatDrawer } from '@angular/material/sidenav';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

@Component({
	selector: 'app-main',
	templateUrl: './AppMainViewComponent.html',
	styleUrls: ['./AppMainViewComponent.scss'],
})
export class AppMainViewComponent extends BaseViewUI implements AfterViewInit {

	public combineCtrl: AppMainViewController;

	public isMedExist = false;
	public medNumber = '';
	private inst = null;

	// 公開イベント定義
	private TARGET_CLASS_DEF = AppViewReceiverConst.General.View.AppMainViewComponent;
	protected EVENT_LIST: Array<Array<any>> = [
		[// スピナーの表示処理
			this.TARGET_CLASS_DEF,
			this.TARGET_CLASS_DEF.ShowSpinner,
			this.showSpinner.bind(this)
		],
		[// スピナーの非表示処理
			this.TARGET_CLASS_DEF,
			this.TARGET_CLASS_DEF.CloseSpinner,
			this.closeSpinner.bind(this)
		]

	];

	// コンポーネントとコントローラーの結合用プロパティは、継承関係上の上書きする。
	// F12での参照が出来うようにする為と、クラス構造で、どのコントローラーと紐づくか明示する為。
	// public combineCtrl: AppMainViewController;


	// 画面差し込み用のコンテナ
	@ViewChild('appContainer', { read: ViewContainerRef, static: false })
	private appContainer: ViewContainerRef;

	constructor(
		public alertCtrl: AlertController,
		public dialogCtrl: MatDialog,
		public loadingCtrl: LoadingController,
		public route: Router
	) {

		// Angulerのコンポーネントなので、上位を呼ぶ必要がある
		super();

		// BaseViewでコントローラのインスタンスを作成して保持する（ロジック系はコントローラに実装する）
		this.createController(AppMainViewController);

		// EVENT_LISTに定義したイベントを登録する。
		this.registerEvent();
	}

	/**
	 * ngAfterViewInit
	 *
	 * Angularのライフサイクル
	 * ビューの初期化後に一度だけ実行される
	 */
	public async ngAfterViewInit() {
		// 自分の初期化処理実行
		await this.start();
	}

	/**
	 * start
	 * 初期化処理
	 */
	public async start() {

		this.log('------------ AppMainViewComponent start ------------');
		this.sendFingerprintLog('AppMainViewComponent', 'show');

		// クエリパラムを取得する
		const queryParams = AppSingletonUtil.getActivatedRoute().snapshot.queryParams;

		// TOP画面以外への画面変更が行われれば処理中断する。
		const isChangeView = await this.dispatchView(queryParams);
		this.log('isChangeView: ' + isChangeView);
		if (isChangeView) {
			return;
		}

		const userInfo = AppSingletonUtil.getUserInfo();
		if (userInfo.medicalRecord && userInfo.medicalRecord.wellnestClinic) {
			this.isMedExist = true;
			this.medNumber = userInfo.medicalRecord.wellnestClinic.medicalRecordNumber;
		}

		// リファラチェック
		const referrer = await this.combineCtrl.getReferrer(this);
		if (referrer === false) {
			// リファラが存在しない場合、最初のViewを表示する
			this.inst = await this.createStartComponent(MainDisplayComponent, this.appContainer);
		} else {
			switch (referrer) {
				case 'pcrform':
					this.route.navigate(['/pcrform']).then(async () => {
						await this.combineCtrl.deleteReferrer(this);
					});
					break;

				case 'reserve':
					this.route.navigate(['/reserve/confirm']).then(async () => {
						await this.combineCtrl.deleteReferrer(this);
					});
					break;
				case 'sas':
					this.route.navigate(['/sas/request']).then(async () => {
						await this.combineCtrl.deleteReferrer(this);
					});
					break;

				case 'examAfterProcess':
					const paymentId = await this.combineCtrl.getPaymentId(this);
					await this.combineCtrl.deleteReferrer(this);
					window.location.href = `/payment?id=${paymentId}`;
					break;

				default:
					this.inst = await this.createStartComponent(MainDisplayComponent, this.appContainer);
					await this.combineCtrl.deleteReferrer(this);
					break;
			}
		}

		// スワイプでロケーションバックを非活性にする
		this.disablePhoneSwipeBack();

	}


	/////////////////////////////////
	// イベント
	/**
	 * onClickLogout
	 * ログアウト処理
	 */
	public async onClickLogout() {

		const svc = new StorageService(this);
		await svc.clear();

		window.location.reload();

	}

	// TODO: 下位レイヤーのメソッドを呼んでいるから、必ずリファクタリングする
	/**
	 * 検査一覧を表示
	 */
	public async onClickShowHome(drawer: MatDrawer) {
		drawer.toggle();
		await this.inst.eventShowHome();
	}

	/**
	 * 検査一覧を表示
	 */
	public async onClickShowMedicalService(drawer: MatDrawer) {
		drawer.toggle();
		await this.inst.eventShowMedicalService();
	}

	/**
	 * 予約一覧
	 * @param drawer
	 */
	public async onClickShowReserve(drawer: MatDrawer) {
		drawer.toggle();
		await this.inst.eventShowReserve();
	}

	/**
	 * 請求一覧を表示
	 */
	public async onClickShowCredit(drawer: MatDrawer) {
		drawer.toggle();
		await this.inst.eventShowCredit();
	}

	/**
	 * 設定画面を表示
	 */
	public async  onClickShowSetting(drawer: MatDrawer) {
		drawer.toggle();
		await this.inst.eventShowSetting();
	}

	/**
	 * showSpinner
	 *
	 * スピナーの表示処理
	 */
	public async showSpinner() {
		await this.showMatSpinnerMatDialog();
	}

	/**
	 * closeSpinner
	 *
	 * スピナーの非表示処理
	 */
	public async closeSpinner() {
		await this.closeMatSpinnerMatDialog();
	}

	////////////////////////////////////////////
	// スピナー、ローディング用の表示制御
	//  MatDialogを使用したMatSpinnerの表示
	private showMatSpinnerMatDialog() {
		// constructorで設定されたMatDialogのプロパティからopenを呼ぶ
		// openが呼ばれたときにダイアログが表示される
		const dialog = this.dialogCtrl.open(ViewSpinnerComponent, {
			// backdropへのクリックを無効にするかのフラグ
			disableClose: true,
		});

		return dialog; // 呼び出し側は戻り値で実体を持っておいて、閉じるときに使う。
	}

	// AngularのMatDialogを閉じる処理
	// 他のダイアログも全て巻き込んで消えるので注意
	private closeMatSpinnerMatDialog() {
		this.dialogCtrl.closeAll(); // 他のダイアログも消えちゃう
	}


	/**
	 * クエリパラムから画面表示切り替えを行う
	 * 画面変更が発生する場合はtrueを返す
	 * @param queryParams クエリパラム
	 * @private
	 */
	private async dispatchView(queryParams: Params): Promise<boolean> {

		// ログイン状態でパスワードリセットトークンが渡された場合
		// ログイントークンを削除して、ログイン画面に渡す。
		const resetToken = queryParams.resetToken;
		if (queryParams.resetToken) {
			await this.combineCtrl.deleteSavedLoginToken();
			await this.route.navigate(['login'], { queryParams: { resetToken } });
			return true;
		}

		// URLによって新規登録画面に飛ばすためのURL設定
		const newUser = queryParams.newUser;
		if (newUser) {
			await this.combineCtrl.deleteSavedLoginToken();
			await this.route.navigate(['login'], { queryParams: { newUser } });
			return true;
		}

		// ログイントークンが存在しているかをチェックする
		// 失敗するとログイン画面
		const ret = await this.execFuncWithErrorHandling(
			this,
			this.combineCtrl.checkUserLogin.bind(this),
			{ view: this }
		);
		if (!ret) {
			await this.route.navigate(['login']);
			return true;
		}

		return false;

	}
}
